<template>

    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg ">

                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Covid-19 Safety Measures</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row justify-content-center mt--100">
                    <div class="col-lg-12">
                        <card gradient="white" shadow>
                            <!--<div class="row mb-4 justify-content-center align-items-center">-->
                                <!--<div class="col-12 col-lg-9">-->
                                    <!--<iframe height="375rem" src="https://www.youtube.com/embed/JceK0Wv9rfA" class="video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--</div>-->
                            <!--</div>-->
                            <h5>{{post.text2}}</h5>
                            <p>{{post.text3}}</p>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                                    <img v-lazy="'img/brand/blog/otc-reopening/hepa-filter.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m6.title}}</h6>
                                    <p>{{post.measures.m6.description}}</p>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                                    <img v-lazy="'img/brand/blog/otc-reopening/distance.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m1.title}}</h6>
                                    <p>{{post.measures.m1.description}}</p>
                                </div>
                            </div>
                            <div class="row mt-3 justify-content-center">
                                <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                                    <img v-lazy="'img/brand/blog/otc-reopening/consent.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m2.title}}</h6>
                                    <p>{{post.measures.m2.description}}
                                        <a href="https://offthecouch.io/checkin/otc"
                                           v-on:click="tracker('Waiver', 'Redirected to waiver', 'Link from covid info page')">
                                          https://offthecouch.io/checkin/otc</a>
                                    </p>
                                </div>
                            </div>
                            <div class="row mt-3 justify-content-center">
                                <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                                    <img v-lazy="'img/brand/blog/otc-reopening/hand-wash.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m3.title}}</h6>
                                    <p>{{post.measures.m3.description}}</p>
                                </div>
                            </div>
                            <div class="row mt-3 justify-content-center">
                                <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                                    <img v-lazy="'img/brand/blog/otc-reopening/spray.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m4.title}}</h6>
                                    <p>{{post.measures.m4.description}}</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "CovidInfo",
        data () {
            return {
                post: {
                    text1: "Off The Couch is happy to announce that we have re-opened for business! Come and join us in an adventure in a private and safe environment.",
                    text2: "Special safety measures",
                    text3: "Our top priority is to keep both our employees and our customers safe. As part of that, we are strictly adhering to the following safety measures:",
                    measures: {
                        m1: {
                            title: "Private Experiences and Reduced Capacity",
                            description: "We are also capping the number of experiences available to 2 per time window.  This ensures that multiple groups remain completely separated. "
                        },
                        m2: {
                            title: "Online Waivers",
                            description: "Waivers are available via the website or directly at"
                        },
                        m3: {
                            title: "Hand Washing, Sanitizer, and Gloves!",
                            description: "All players are strongly encouraged to wash their hands before and after each experience. Hand sanitizer and gloves will also be offered to all players."
                        },
                        m4: {
                            title: "More Cleaning!",
                            description: "Employees will have an additional 30 minutes between experiences to reset and thoroughly clean all handled items and surfaces with medical-grade disinfectants."
                        },
                        m6: {
                            title: "Medical Grade H13 True HEPA Air Purifier",
                            description: "To ensure the safest experience we have recently installed Medical Grade H13 True HEPA Air purification into our experiences."
                        },
                    }
                }
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>
    .video {
        /*height: 100%;*/
        width: 100%;
        object-fit: fill;
        position: relative;
    }

</style>
